@if (jwtToken) {
    <fin-metabase-dashboard [token]="jwtToken" [withTitle]="true" [withDownloads]="true" [initialParameters]="initialParameters">
    </fin-metabase-dashboard>
} @else {
    <p>Token Generation in progress...</p>
}
